//import { Link } from 'gatsby-plugin-react-i18next';
import PropTypes from 'prop-types';

import ImageDisplay from '../imageDisplay';

const HomeBanner = ({ title, description, image, cta }) => {
	return (
		<div className="home-banner bg--secondary">
			<div className="home-banner__body">
				<h1 className="typography typography--h1 typography--white home-banner__text--desktop">
					{title}
				</h1>
				<hr className="hr hr--gradient-orange" />
				<p className="typography typography--body-big typography--white home-banner__text--desktop">
					{description?.description}
				</p>
				{cta && (
					<a
						href={cta.link}
						className="btn btn--desktop"
						target="_blank"
						rel="noreferrer"
					>
						{cta.title}
					</a>
				)}
				<ImageDisplay
					className="home-banner__img"
					alt={image?.description}
					image={image?.gatsbyImageData}
					src={image?.file?.url}
				/>
			</div>
		</div>
	);
};

HomeBanner.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.shape({ description: PropTypes.string.isRequired }),
	image: PropTypes.shape({
		gatsbyImageData: PropTypes.object,
		file: PropTypes.shape({ url: PropTypes.string }),
		description: PropTypes.string,
	}),
	cta: PropTypes.shape({
		title: PropTypes.string,
		link: PropTypes.string,
	}),
};

HomeBanner.defaultProps = {
	image: null,
	cta: null,
};

export default HomeBanner;
